import {
  isRunningInNativeApp,
  nativeSupportsShareFile,
} from '~/client/src/shared/utils/nativeBridge'

export type ExportHandOff = 'share' | 'native' | 'download' | 'none'

// Asked with a stand-in file, so it needs no tap: sharing files is per browser, not per file.
const canShareFiles = (): boolean =>
  navigator.canShare?.({
    files: [new File([''], 'probe.png', { type: 'image/png' })],
  }) ?? false

// How a phone hands an export over: the share sheet where it takes files, else the native app's
// own (Android's WebView has no Web Share), else a download in a browser. The native app's WebView
// cannot download a blob, so a build without SHARE-FILE gets none.
export const exportHandOff = (): ExportHandOff => {
  if (canShareFiles()) return 'share'
  if (nativeSupportsShareFile()) return 'native'
  return isRunningInNativeApp() ? 'none' : 'download'
}

// Must run from the tap that asked for it. Closing the share sheet is not a failure.
export async function shareExportFile(
  file: File,
): Promise<'shared' | 'cancelled'> {
  try {
    await navigator.share({ files: [file], title: file.name })
    return 'shared'
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      return 'cancelled'
    }
    throw error
  }
}
